import Config from 'config/settings';
import { Events } from 'core/events/Events';
import { DOMHelper } from 'core/DOMHelper';
import { SidePagingClickEvent } from 'app/events/SidePagingClickEvent';
import { UIThemeColourType } from 'app/data/Enums';

interface ItemConfig {
	label: string;
	targetSelector: string;
}

interface Item {
	target: HTMLElement;
	targetSelector: string;
}

export class SidePaging {
	private _items: Array<Item>;
	private _activeIndex: number = 1;

	constructor(
		public container: HTMLElement,
		public dom: DOMHelper
	) {
		Events.on('click', '.project__sidepaging__item', this._onItemClick.bind(this));
	}

	public create(itemsData: Array<ItemConfig>): void {
		this._createItemsHTML(itemsData);
	}

	public destroy(): void {
		this._items = null;
	}

	public show(): void {
		gsap.TweenMax.fromTo(
			this.container,
			0.3,
			{ autoAlpha: 0 },
			{ autoAlpha: 1, ease: Config.linearEase, delay: 0.6 }
		);
	}

	public hide(): void {
		gsap.TweenMax.to(this.container, 0.3, { autoAlpha: 0, ease: Config.linearEase, delay: 0 });
	}

	public selectIndex(index: number, theme: UIThemeColourType): void {
		if (theme === UIThemeColourType.DARK) {
			this.dom.addClass(this.container, '-dark');
		} else {
			this.dom.removeClass(this.container, '-dark');
		}

		this._selectIndex(index);
	}

	//Private
	//----------------------------------------------------------------
	private _onItemClick(e: MouseEvent): boolean {
		e.preventDefault();
		this._selectIndex(parseInt((e.target as HTMLElement).getAttribute('data-index'), 10));
		Events.dispatch(
			new SidePagingClickEvent({
				index: this._activeIndex,
				targetSelector: this._items[this._activeIndex].targetSelector
			})
		);
		return false;
	}

	private _selectIndex(index: number): void {
		this._activeIndex = index;
		this._setSelectedState();
	}

	private _createItemsHTML(itemsData: Array<ItemConfig>): void {
		let html = '';
		itemsData.forEach((config: ItemConfig, index: number) => {
			html += this._createItemHTML(config, index);
		});
		this.dom.setHTML(this.container, html, () => this._createItems(itemsData));
	}

	private _createItemHTML(config: ItemConfig, index: number): string {
		return `<a class='project__sidepaging__item -index${index}' data-index='${index}' href='#'>
		${config.label}
		</a>`;
	}

	private _createItems(itemsData: Array<ItemConfig>): void {
		this._items = [];
		itemsData.forEach((config: ItemConfig, index: number) => {
			this._items.push({
				target: this.container.querySelector(`.project__sidepaging__item.-index${index}`),
				targetSelector: config.targetSelector
			});
		});
	}

	private _setSelectedState(): void {
		if (!this._items) {
			return;
		}

		this._items.forEach((item: Item, index: number) => {
			if (index === this._activeIndex) {
				this.dom.addClass(item.target, '-selected');
			} else {
				this.dom.removeClass(item.target, '-selected');
			}
		});
	}
}
